import classNames from "classnames";
import Radio from "@/components/UI/Radio/Radio";
import List from "@/components/UI/List/List";
import ListItem from "@/components/UI/List/ListItem";
import { ButtonCreatorConfig } from "./utils";
import Widget from "@/components/Widget/Widget";

interface DesignPageProps extends React.HTMLAttributes<HTMLElement> {
  onSettingsChange?: (nextSettings: ButtonCreatorConfig) => void;
  section: any;
  settings?: ButtonCreatorConfig;
}

const DesignPage = ({ className, onSettingsChange, section, settings, ...props }: DesignPageProps) => {
  return (
    <div className={classNames("divide-y px-16", className)} {...props}>
      {section?.DesignType01Radio && (
        <div className="flex py-12">
          <div className="flex flex-1 gap-10">
            <Radio
              checked={settings?.designType === section?.DesignType01Radio?.Value}
              className="flex-1"
              id={section?.DesignType01Radio?.HtmlId}
              label={section?.DesignType01Radio?.Label}
              name={section?.DesignType01Radio?.Name}
              onChange={() => {
                onSettingsChange?.({
                  designType: section?.DesignType01Radio?.Value,
                });
              }}
            />
            <div className="flex flex-col gap-2">
              {section?.DesignType03ListTitle && (
                <div className="text-sm font-bold">{section?.DesignType01ListTitle}</div>
              )}
              {section?.DesignType01List?.length > 0 && (
                <List disableBeams>
                  {section?.DesignType01List?.map((item: any) => {
                    return (
                      <ListItem
                        className="text-sm text-vpGray-700"
                        disableGutters
                        key={item?.id}
                        passive
                        startNode={
                          item?.StartNode?.data?.attributes && (
                            <div
                              className={classNames("h-5 w-5", item?.StartNodeClassName)}
                              style={{
                                mask: `url(${item?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                                WebkitMask: `url(${item?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                                ...item?.StartNodeStyle,
                              }}
                            />
                          )
                        }
                      >
                        {item?.Value}
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </div>
          </div>
          <div className="flex flex-1 items-center justify-end">
            <Widget
              backgroundType="white"
              buttonColor="#1882ff"
              buttonLabel="Notify Me"
              compareType="visual"
              crop={{ x: "218", y: "84", height: "1005", width: "586" }}
              designType="small"
              id="design-page-small-widget"
              threshold="1"
              url={btoa("www.google.com")}
            />
          </div>
        </div>
      )}
      {section?.DesignType02Radio && (
        <div className="flex py-12">
          <div className="flex flex-1 gap-10">
            <Radio
              checked={settings?.designType === section?.DesignType02Radio?.Value}
              className="flex-1"
              id={section?.DesignType02Radio?.HtmlId}
              label={section?.DesignType02Radio?.Label}
              name={section?.DesignType02Radio?.Name}
              onChange={() => {
                onSettingsChange?.({
                  designType: section?.DesignType02Radio?.Value,
                });
              }}
            />
            <div className="flex flex-col gap-2">
              {section?.DesignType03ListTitle && (
                <div className="text-sm font-bold">{section?.DesignType02ListTitle}</div>
              )}
              {section?.DesignType02List?.length > 0 && (
                <List disableBeams>
                  {section?.DesignType02List?.map((item: any) => {
                    return (
                      <ListItem
                        className="text-sm text-vpGray-700"
                        disableGutters
                        key={item.id}
                        passive
                        startNode={
                          item?.StartNode?.data?.attributes && (
                            <div
                              className={classNames("h-5 w-5", item?.StartNodeClassName)}
                              style={{
                                mask: `url(${item?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                                WebkitMask: `url(${item?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                                ...item?.StartNodeStyle,
                              }}
                            />
                          )
                        }
                      >
                        {item?.Value}
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </div>
          </div>
          <div className="flex flex-1 items-center justify-end">
            <Widget
              backgroundType="white"
              buttonColor="#1882ff"
              buttonLabel="Notify Me"
              compareType="visual"
              crop={{ x: "218", y: "84", height: "1005", width: "586" }}
              designType="medium"
              id="design-page-medium-widget"
              threshold="1"
              url={btoa("www.google.com")}
            />
          </div>
        </div>
      )}
      {section?.DesignType03Radio && (
        <div className="flex py-12">
          <div className="flex flex-1 gap-10">
            <Radio
              checked={settings?.designType === section?.DesignType03Radio?.Value}
              className="flex-1"
              id={section?.DesignType03Radio?.HtmlId}
              label={section?.DesignType03Radio?.Label}
              name={section?.DesignType03Radio?.Name}
              onChange={() => {
                onSettingsChange?.({
                  designType: section?.DesignType03Radio?.Value,
                });
              }}
            />
            <div className="flex flex-col gap-2">
              {section?.DesignType03ListTitle && (
                <div className="text-sm font-bold">{section?.DesignType03ListTitle}</div>
              )}
              {section?.DesignType03List?.length > 0 && (
                <List disableBeams>
                  {section?.DesignType03List?.map((item: any) => {
                    return (
                      <ListItem
                        className="text-sm text-vpGray-700"
                        disableGutters
                        key={item?.id}
                        passive
                        startNode={
                          item?.StartNode?.data?.attributes && (
                            <div
                              className={classNames("h-5 w-5", item?.StartNodeClassName)}
                              style={{
                                mask: `url(${item?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                                WebkitMask: `url(${item?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                                ...item?.StartNodeStyle,
                              }}
                            />
                          )
                        }
                      >
                        {item?.Value}
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </div>
          </div>
          <div className="relative flex flex-1 items-center justify-end">
            <Widget
              backgroundType="white"
              buttonColor="#1882ff"
              buttonLabel="Notify Me"
              compareType="visual"
              crop={{ x: "218", y: "84", height: "1005", width: "586" }}
              designType="link-only"
              id="design-page-medium-widget"
              threshold="1"
              url={btoa("www.google.com")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DesignPage;
